export default __webpack_public_path__ + "static/media/successfully.0c0049bc.svg";